import { toast } from "react-toastify";

export const alertError = async (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
  });
};

export const alertSuccess = async (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 1500,
  });
};
export const alertInfo = async (message) => {
  toast.info(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 1500,
  });
};
